<div class="card-btn-wrap">
    <div (click)="redirect($event, 1)" class="buyer-deal-card">
        <div class="left-side">
            <div class="deal-image-container">
                <img [src]="vehicleImage" (error)="showMissingImage($event)" alt="image of vehicle you've purchased" />
            </div>
        </div>
        <div class="right-side">
            <div class="check-title-wrap">
                <p *ngIf="deal.vehicle.year > 0" style="font-size: 17px; margin-bottom: 5px">
                    <b>{{ deal.vehicle?.year }} {{ deal.vehicle?.make }} {{ deal.vehicle?.model }}</b>
                </p>
                <ng-container *ngIf="deal.statusId === 2 || deal.statusId === 3"><mat-icon style="color: #1a8a2e">verified</mat-icon></ng-container>
            </div>
            <p>
                VIN: <b>{{ deal.vehicle?.vin }}</b>
            </p>
            <div class="info-container">
                <p>
                    <b>{{ deal.dealershipName }}</b>
                </p>
            </div>
        </div>
    </div>
    <button (click)="redirect($event, 1)" mat-button class="buyer-primary">View Documents</button>
</div>
